import { DropdownMenuItemType } from '@bingads-webui-react/fabric-control';

const partnerTrafficString = _TL_('Eligible to serve on partner traffic');
const onoTrafficString = _TL_('Eligible to serve on Microsoft sites');

const standard = [{
  width: 970,
  height: 250,
  text: _TL_('970 x 250 — Billboard'),
  sizeText: _TL_('970 x 250'),
  targetText: _TL_('Billboard'),
}, {
  width: 970,
  height: 90,
  text: _TL_('970 x 90 — Super leaderboard'),
  sizeText: _TL_('970 x 90'),
  targetText: _TL_('Super leaderboard'),
}, {
  width: 728,
  height: 90,
  text: _TL_('728 x 90 — Leaderboard'),
  sizeText: _TL_('728 x 90'),
  targetText: _TL_('Leaderboard'),
}, {
  width: 468,
  height: 60,
  text: _TL_('468 x 60 — Full banner'),
  sizeText: _TL_('468 x 60'),
  targetText: _TL_('Full banner'),
}, {
  width: 336,
  height: 280,
  text: _TL_('336 x 280 — Large rectangle'),
  sizeText: _TL_('336 x 280'),
  targetText: _TL_('Large rectangle'),
}, {
  width: 300,
  height: 600,
  text: _TL_('300 x 600 — Half-page'),
  sizeText: _TL_('300 x 600'),
  targetText: _TL_('Half-page'),
}, {
  width: 300,
  height: 250,
  text: _TL_('300 x 250 — Medium rectangle'),
  sizeText: _TL_('300 x 250'),
  targetText: _TL_('Medium rectangle'),
}, {
  width: 250,
  height: 250,
  text: _TL_('250 x 250 — Square'),
  sizeText: _TL_('250 x 250'),
  targetText: _TL_('Square'),
}, {
  width: 234,
  height: 60,
  text: _TL_('234 x 60 — Half-banner'),
  sizeText: _TL_('234 x 60'),
  targetText: _TL_('Half-banner'),
}, {
  width: 180,
  height: 150,
  text: _TL_('180 x 150 — Rectangle'),
  sizeText: _TL_('180 x 150'),
  targetText: _TL_('Rectangle'),
}, {
  width: 160,
  height: 600,
  text: _TL_('160 x 600 — Wide skyscraper'),
  sizeText: _TL_('160 x 600'),
  targetText: _TL_('Wide skyscraper'),
}, {
  width: 120,
  height: 600,
  text: _TL_('120 x 600 — Skyscraper'),
  sizeText: _TL_('120 x 600'),
  targetText: _TL_('Skyscraper'),
}];

const mobile = [{
  width: 480,
  height: 320,
  text: _TL_('480 x 320 — Landscape (interstitial)'),
  sizeText: _TL_('480 x 320'),
  targetText: _TL_('Landscape (interstitial)'),
}, {
  width: 320,
  height: 480,
  text: _TL_('320 x 480 — Portrait (interstitial)'),
  sizeText: _TL_('320 x 480'),
  targetText: _TL_('Portrait (interstitial)'),
}, {
  width: 320,
  height: 100,
  text: _TL_('320 x 100 — Large banner'),
  sizeText: _TL_('320 x 100'),
  targetText: _TL_('Large banner'),
}, {
  width: 320,
  height: 50,
  text: _TL_('320 x 50 — Leaderboard'),
  sizeText: _TL_('320 x 50'),
  targetText: _TL_('Leaderboard'),
}, {
  width: 300,
  height: 50,
  text: _TL_('300 x 50 — Banner'),
  sizeText: _TL_('300 x 50'),
  targetText: _TL_('Banner'),
}, {
  width: 216,
  height: 36,
  text: _TL_('216 x 36 — Large banner'),
  sizeText: _TL_('216 x 36'),
  targetText: _TL_('Large banner'),
}, {
  width: 168,
  height: 28,
  text: _TL_('168 x 28 — Medium banner'),
  sizeText: _TL_('168 x 28'),
  targetText: _TL_('Medium banner'),
}, {
  width: 120,
  height: 20,
  text: _TL_('120 x 20 — Small banner'),
  sizeText: _TL_('120 x 20'),
  targetText: _TL_('Small banner'),
}];

const getSupportedSize = (supportedSize, source) => {
  if (!supportedSize || !source) {
    return [];
  }

  return source.filter(sourceSize => supportedSize.some(baseSize => baseSize.width === sourceSize.width && baseSize.height === sourceSize.height));
};

const getStandardOnO = () => {
  const supportedSize = [{
    width: 300,
    height: 250,
  }, {
    width: 728,
    height: 90,
  }, {
    width: 300,
    height: 600,
  }, {
    width: 160,
    height: 600,
  }, {
    width: 970,
    height: 250,
  }];

  return getSupportedSize(supportedSize, standard);
};

const getStandardOthers = () => {
  const supportedSize = [{
    width: 336,
    height: 280,
  }, {
    width: 250,
    height: 250,
  }, {
    width: 120,
    height: 600,
  }, {
    width: 970,
    height: 90,
  }, {
    width: 468,
    height: 60,
  }, {
    width: 234,
    height: 60,
  }, {
    width: 180,
    height: 150,
  }];

  return getSupportedSize(supportedSize, standard);
};

const getMobileOnO = () => {
  const supportedSize = [{
    width: 320,
    height: 50,
  }];

  return getSupportedSize(supportedSize, mobile);
};

const getMobileOthers = () => {
  const supportedSize = [{
    width: 320,
    height: 100,
  }, {
    width: 320,
    height: 480,
  }, {
    width: 480,
    height: 320,
  }, {
    width: 120,
    height: 20,
  }, {
    width: 300,
    height: 50,
  }, {
    width: 216,
    height: 36,
  }, {
    width: 168,
    height: 28,
  }];

  return getSupportedSize(supportedSize, mobile);
};

const getOptionsTranslated = (
  i18n,
  sourceWidth,
  sourceHeight,
  sourceOptions
) => {
  const resultOptions = [];
  sourceOptions.forEach(({
    width,
    height,
    text,
    sizeText,
    targetText,
  }) => {
    if ((!sourceHeight || sourceHeight >= height) && (!sourceWidth || sourceWidth >= width)) {
      resultOptions.push({
        key: `Image${width}x${height}`,
        width,
        height,
        text: i18n.getString(text),
        sizeText: i18n.getString(sizeText),
        targetText: i18n.getString(targetText),
      });
    }
  });

  return resultOptions;
};

export const getAllStandardOptions = () => getStandardOnO().concat(getStandardOthers());

export const getAllMobileOptions = () => getMobileOnO().concat(getMobileOthers());

export const getStandardTargetOptions = ({
  i18n,
  sourceWidth,
  sourceHeight,
}) => {
  const standardOnO = getStandardOnO();
  const standardOnoOptions = getOptionsTranslated(i18n, sourceWidth, sourceHeight, standardOnO);
  const standardOthers = getStandardOthers();
  const standardOtherOptions = getOptionsTranslated(i18n, sourceWidth, sourceHeight, standardOthers);

  const options = [
    ...(standardOnoOptions.length > 0 ? [{
      key: 'standardOnoPlacements',
      text: i18n.getString(onoTrafficString),
      itemType: DropdownMenuItemType.Header,
    }]: []),
    ...standardOnoOptions,
    ...(standardOnoOptions.length > 0 ? [{
      key: 'divider',
      itemType: DropdownMenuItemType.Divider,
    }]: []),
    ...(standardOtherOptions.length > 0 ? [{
      key: 'standardOtherPlacements',
      text: i18n.getString(partnerTrafficString),
      itemType: DropdownMenuItemType.Header,
    }]:[]),
    ...standardOtherOptions,
  ];

  return options;
};

export const getMobileTargetOptions = ({
  i18n,
  sourceWidth,
  sourceHeight,
}) => {
  const mobileOnO = getMobileOnO();
  const mobileOnoOptions = getOptionsTranslated(i18n, sourceWidth, sourceHeight, mobileOnO);
  const mobileOthers = getMobileOthers();
  const mobileOtherOptions = getOptionsTranslated(i18n, sourceWidth, sourceHeight, mobileOthers);

  const options = [
    ...(mobileOnoOptions.length > 0 ? [{
      key: 'mobileOnoPlacements',
      text: i18n.getString(onoTrafficString),
      itemType: DropdownMenuItemType.Header,
    }]: []),
    ...mobileOnoOptions,
    ...(mobileOnoOptions.length > 0 ? [{
      key: 'divider',
      itemType: DropdownMenuItemType.Divider,
    }]: []),
    ...(mobileOtherOptions.length > 0 ? [{
      key: 'mobileOtherPlacements',
      text: i18n.getString(partnerTrafficString),
      itemType: DropdownMenuItemType.Header,
    }]:[]),
    ...mobileOtherOptions,
  ];

  return options;
};

export const getTargetOptions = ({
  i18n,
  sourceWidth,
  sourceHeight,
}) => {
  const standardOptions = [];
  standard.forEach(({
    width,
    height,
    text,
    sizeText,
    targetText,
  }) => {
    if ((!sourceHeight || sourceHeight >= height) && (!sourceWidth || sourceWidth >= width)) {
      standardOptions.push({
        key: `Image${width}x${height}`,
        width,
        height,
        text: i18n.getString(text),
        sizeText: i18n.getString(sizeText),
        targetText: i18n.getString(targetText),
      });
    }
  });

  const mobileOptions = [];
  mobile.forEach(({
    width,
    height,
    text,
    sizeText,
    targetText,
  }) => {
    if ((!sourceHeight || sourceHeight >= height) && (!sourceWidth || sourceWidth >= width)) {
      mobileOptions.push({
        key: `Image${width}x${height}`,
        width,
        height,
        text: i18n.getString(text),
        sizeText: i18n.getString(sizeText),
        targetText: i18n.getString(targetText),
      });
    }
  });

  const options = [
    ...(standardOptions.length > 0 ? [{
      key: 'standard',
      text: i18n.getString(_TL_('Standard')),
      itemType: DropdownMenuItemType.Header,
    }]: []),
    ...standardOptions,
    ...(standardOptions.length > 0 ? [{
      key: 'divider',
      itemType: DropdownMenuItemType.Divider,
    }]: []),
    ...(mobileOptions.length > 0 ? [{
      key: 'Mobile',
      text: i18n.getString(_TL_('Mobile')),
      itemType: DropdownMenuItemType.Header,
    }]:[]),
    ...mobileOptions,
  ];

  return options;
};
